<main class="main-wrap">
  <div class="left-sidebar-wrapper" *ngIf="this.deviceType !== 'mobile'">
    <app-profile-page-left-side-bar></app-profile-page-left-side-bar>
  </div>
  <div class="middle-wrapper">
    <div *ngIf="!changePasswordFlag">
      <app-profile-component></app-profile-component>
    </div>
    <div *ngIf="changePasswordFlag">
      <app-change-password></app-change-password>
    </div>
  </div>
  <div class="right-sidebar-wrapper" *ngIf="this.deviceType !== 'mobile'">
    <!-- <app-profile-page-right-side-bar></app-profile-page-right-side-bar> -->
    <app-industry-report-suggestion></app-industry-report-suggestion>
  </div>
</main>
